module.exports = __webpack_public_path__ + "media/warranty-claim/shingle-sample-55847552.png";